import { useQuery } from '@apollo/client';
import { useState } from 'react';
import { FilterWrapper } from 'src/components/common/wrapper/filter/wrapper';
import {
  FieldOfficeCountOtpListReportingDocument,
  FieldOfficeCountOtpListReportingQuery,
  FieldOfficeListReportingFilterInput,
  SortingDirection,
} from 'src/graphql/generated/graphql';
import { useTable } from 'src/hooks/use-table';
import { FieldOfficeCountOtpReportFilter } from './filter/filter';
import { FieldOfficeCountOtpTable } from './table';
import { ContentWrapper } from 'src/components/common/wrapper/content/wrapper';
import { TableWrapper } from 'src/components/common/wrapper/table/wrapper';

const PAGINATION_LIMIT = 20;

export const FieldOfficeCountOtpReport = () => {
  const [totalCount, setTotalCount] = useState(0);

  const { page, setPage, filter, onFilterChange, defaultFilter } = useTable<
    FieldOfficeListReportingFilterInput,
    Record<string, SortingDirection>
  >();

  const { loading, data } = useQuery<FieldOfficeCountOtpListReportingQuery>(
    FieldOfficeCountOtpListReportingDocument,
    {
      variables: {
        filter,
        pagination: {
          limit: PAGINATION_LIMIT,
          offset: page * PAGINATION_LIMIT,
        },
      },
      onCompleted: (data) =>
        setTotalCount(
          data?.fieldOfficeCountOTPListReporting?.pagination?.totalCount,
        ),
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-and-network',
    },
  );

  const fieldOfficeCountOtp =
    data?.fieldOfficeCountOTPListReporting?.records || [];

  return (
    <>
      <FilterWrapper>
        <FieldOfficeCountOtpReportFilter
          onSubmit={onFilterChange}
          defaultFilter={defaultFilter}
        />
      </FilterWrapper>
      <ContentWrapper>
        <TableWrapper>
          <FieldOfficeCountOtpTable
            data={fieldOfficeCountOtp}
            loading={loading}
            options={{
              page,
              count: totalCount,
              rowsPerPage: PAGINATION_LIMIT,
              onChangePage: setPage,
              enableNestedDataAccess: '.',
            }}
          />
        </TableWrapper>
      </ContentWrapper>
    </>
  );
};
